import React from "react";

const HomeCooperateCard = ({ imgSrc, description, title, inverse }) => {
  return (
    <div className="corporateValueCard">
      <h3 className="corporateValueCardTitle">{title}</h3>
      <p className="corporateValueCardDescription">{description}</p>
    </div>
  );
};

export default HomeCooperateCard;
